'use strict';

goog.provide("Ntry.Utils");

goog.require("Ntry.STATIC");

Ntry.Utils.generateHash = function() {
    return ('0000' + (Math.random()*Math.pow(36,4) << 0).toString(36)).substr(-4);
}

Ntry.createElement = function(type, parent, elementId) {
    var element = document.createElement(type);
    if (elementId)
        element.id = elementId;
    var classes = Array.prototype.splice.call(arguments,3);

    element.hasClass = function(className) {
        return this.className.match(new RegExp('(\\s|^)'+className+'(\\s|$)'));
    }
    element.addClass = function(className) {
        for (var i = 0; i < arguments.length; i++) {
            var className = arguments[i];
            if (!this.hasClass(className)) this.className += " " + className;
        }
    }
    element.removeClass = function(className) {
        for (var i = 0; i < arguments.length; i++) {
            var className = arguments[i];
            if (this.hasClass(className)) {
                var reg = new RegExp('(\\s|^)'+className+'(\\s|$)');
                this.className=this.className.replace(reg,' ');
            }
        }
    }

    element.removeClasses = function() {
        var that = this;
        var classes = this.className.split(' ');
        classes.map(function (className) {
            var trimmed = className.trim();
            if (trimmed.length != 0)
                that.removeClass(trimmed);
        });
    }

    element.ntryShow = function(type) {
        this.removeClass('ntryRemove');
        if (type) {
            this.addClass(type);//ntryShowInline,ntryShowInlineBlock
        } else {
            this.addClass('ntryShow');
        }
    }

    element.ntryRemove = function() {
        this.removeClass('ntryShow');
        this.removeClass('ntryShowInline');
        this.removeClass('ntryShowInlineBlock');
        this.addClass('ntryRemove');
    }

    element.bindOnClick = function(func) {
        $(this).on('click touchstart', func);
    }

    element.rebindOnClick = function(func) {
        $(this).unbind('click touchstart').bind('click touchstart', func);
    }

    classes.map(function(className){
        element.addClass(className);
    });

    if (parent)
        parent.appendChild(element);

    return element;
};

Ntry.createTileEntities = function(tileMap) {
    if (!tileMap)
        return [];
    var entities = [];
    for (var y in tileMap) {
        for (var x in tileMap[y]) {
            var image = tileMap[y][x];
            var components = {};
            var tileType;
            if (image.substr(0, 4) == "road")
                tileType = Ntry.STATIC.ROAD;
            else
                tileType = Ntry.STATIC.WALL;
            components[Ntry.STATIC.GRID] = {
                x: Number(x), y: Number(y)
            };
            components[Ntry.STATIC.BITMAP] = {
                image: image
            }
            components[Ntry.STATIC.TILE] = {
                tileType: tileType
            }
            entities.push({
                components: components
            })
        }
    }
    return entities;
};

Ntry.createFenceEntities = function(fences) {
    if (!fences)
        return [];
    var entities = [];
    for (var i in fences) {
        var fence = fences[i];
        var components = {};
        var tileType;
        components[Ntry.STATIC.GRID] = {
            x: fence.x, y: fence.y
        };
        components[Ntry.STATIC.BITMAP] = {
            image: fence.image,
            rotation: fence.rotation
        }
        entities.push({
            components: components
        })
    }
    return entities;
};

Ntry.createObstacleEntities = function(obstacles) {
    if (!obstacles)
        return [];
    var entities = [];
    for (var i in obstacles) {
        var obstacle = obstacles[i];
        var components = {};
        var tileType;
        components[Ntry.STATIC.GRID] = {
            x: obstacle.x, y: obstacle.y
        };
        components[Ntry.STATIC.BITMAP] = {
            image: obstacle.image,
            rotation: obstacle.rotation
        }
        components[Ntry.STATIC.TILE] = {
            tileType: obstacle.type
        }
        entities.push({
            components: components
        })
    }
    return entities;
};

Ntry.createGoalEntities = function(goals) {
    if (!goals)
        return [];
    var entities = [];
    for (var i in goals) {
        var goal = goals[i];
        var components = {};
        var tileType;
        components[Ntry.STATIC.GRID] = {
            x: goal.x, y: goal.y
        };
        components[Ntry.STATIC.BITMAP] = {
            image: goal.image
        }
        components[Ntry.STATIC.TILE] = {
            tileType: Ntry.STATIC.GOAL
        }
        components[Ntry.STATIC.ITEM] = {
            itemType: Ntry.STATIC.GOAL_ITEM,
            sequence: goal.sequence
        }
        entities.push({
            components: components
        })
    }
    return entities;
};

Ntry.createJRItemEntities = function(goals) {
    if (!goals)
        return [];
    var entities = [];
    for (var i in goals) {
        var goal = goals[i];
        var components = {};
        var tileType;
        components[Ntry.STATIC.GRID] = {
            x: goal.x, y: goal.y
        };
        components[Ntry.STATIC.BITMAP] = {
            image: goal.image
        }
        components[Ntry.STATIC.TILE] = {
            tileType: Ntry.STATIC.GOAL
        }
        components[Ntry.STATIC.ITEM] = {
            itemType: Ntry.STATIC.JR_ITEM,
            sequence: goal.sequence
        }
        entities.push({
            components: components
        })
    }
    return entities;
};


Ntry.createPlayerEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/entry_bot',
        width: 68,
        height: 115,
        regY: 102,
        regX: 34
    };
    var direction = player.direction ? player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.SCRIPT_CONTAINER] = {
        script: player.userScript || player.script
    };
    return {
        components: components
    };
};

Ntry.createCarPlayerEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/entry_car',
        width: 68,
        height: 115,
        regY: 80,
        regX: 34
    };
    var direction = player.direction ? player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    var code = player.userCode || player.code;

    components[Ntry.STATIC.CODE] = {code: code};

    return {
        components: components
    };
};

Ntry.createSoffyEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/soffy',
        width: 68,
        height: 115,
        regY: 90,
        regX: 34
    };
    var direction = player.direction ? player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.SCRIPT_CONTAINER] = {
        script: player.userScript || player.script
    };
    return {
        components: components
    };
};

Ntry.createJuniEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/juni_v2',
        width: 68,
        height: 115,
        regY: 90,
        regX: 34
    };
    var direction = player.direction ?
        player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.CODE] = {code: player.userCode || player.code};

    return {
        components: components
    };
};

Ntry.createJuniEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/juni_v2',
        width: 68,
        height: 115,
        regY: 90,
        regX: 34
    };
    var direction = player.direction ?
        player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.CODE] = {code: player.userCode || player.code};

    return {
        components: components
    };
};

Ntry.createMazeJuniEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/entry_bot',
        width: 68,
        height: 115,
        regY: 90,
        regX: 34
    };
    var direction = player.direction ?
        player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.CODE] = {code: player.userCode || player.code};

    return {
        components: components
    };
};



Ntry.createCpartyJuniEntity = function(player) {
    if (!player)
        return [];
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: player.x, y: player.y
    };
    components[Ntry.STATIC.SPRITE] = {
        image: '../../sprite/cparty_entry',
        width: 68,
        height: 115,
        regY: 90,
        regX: 34
    };
    var direction = player.direction ?
        player.direction : Ntry.STATIC.EAST;
    components[Ntry.STATIC.UNIT] = {
        direction: direction
    };

    components[Ntry.STATIC.CODE] = {code: player.userCode || player.code};

    return {
        components: components
    };
};



Ntry.createSpaceEntity = function(stageId) {
    if (!stageId)
        return [];
    var bg = {components: {}};
    bg.components[Ntry.STATIC.BITMAP] = {
        image: 'stage_' + (Number(stageId) - 20),
        regX: 0, regY: 0
    };
    bg.components[Ntry.STATIC.POSITION] = {
        x: 0, y: 0
    };
    bg.components[Ntry.STATIC.GRID] = {
        x: 0, y: 0
    };
    var grid = {components: {}};
    grid.components[Ntry.STATIC.BITMAP] = {
        image: 'grid_' + (Number(stageId) - 20),
        regX: 0, regY: 0
    };
    grid.components[Ntry.STATIC.POSITION] = {
        x: 0, y: 0
    };
    grid.components[Ntry.STATIC.GRID] = {
        x: 0, y: 0
    };
    return [bg, grid];
};

Ntry.createSpace = function(spaceMap, stageId) {
    if (!spaceMap)
        return [];
    var entities = [];
    for (var y in spaceMap) {
        for (var x in spaceMap[y]) {
            var tileType = spaceMap[y][x];
            switch (spaceMap[y][x]) {
                case 0:
                    break;
                case 1:
                    entities.push(Ntry.createMeteo(x, y));
                    break;
                case 2:
                    entities.push(Ntry.createSpaceItem(x, y));
                    break;
            }
        }
    }

    var mapSize = spaceMap[0].length;
    Ntry.configManager.setConfig("spaceWidth", mapSize);
    Ntry.systemManager.updateConfig();
    entities.push(Ntry.createPlanet(mapSize, 0, null));
    entities.push(Ntry.createPlanet(mapSize, 1, stageId));
    entities.push(Ntry.createPlanet(mapSize, 2, null));
    return entities;
};

Ntry.createMeteo = function(x, y) {
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: Number(x), y: Number(y)
    };
    var num = Math.floor(Math.random()*8 + 1);
    if (num == 9)
        num = 8;
    components[Ntry.STATIC.BITMAP] = {
        image: 'obstacle_' + num,
        regX: 25, regY: 25
    }
    components[Ntry.STATIC.ITEM] = {
        tolerance: 40,
        itemType: Ntry.STATIC.AI_METEO
    }
    components[Ntry.STATIC.ANIMATE] = {
        animateType: Ntry.STATIC.ROTATE_INFINITE,
        animateValue: Math.random() * 10 - 5
    }
    components[Ntry.STATIC.TILE] = {
        tileType: Ntry.STATIC.OBSTACLE_METEO
    }
    return {components: components};
}

Ntry.createPlanet = function(x, y, stageId) {
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: Number(x), y: Number(y)
    };
    if (stageId) {
        components[Ntry.STATIC.BITMAP] = {
            image: 'goal_' + (Number(stageId) - 20),
            regX: 113 / 2 + 10, regY: 113
        }
    }
    components[Ntry.STATIC.ITEM] = {
        tolerance: 5,
        itemType: Ntry.STATIC.AI_GOAL
    }
    components[Ntry.STATIC.TILE] = {
        tileType: Ntry.STATIC.GOAL
    }
    return {components: components};
};

Ntry.createSpaceItem = function(x, y) {
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: Number(x), y: Number(y)
    };
    components[Ntry.STATIC.SPRITE] = {
        image: "../../sprite/item",
        width: 60,
        height: 60,
        regY: 30,
        regX: 30
    };
    components[Ntry.STATIC.ITEM] = {
        tolerance: 40,
        itemType: Ntry.STATIC.AI_ITEM
    }
    components[Ntry.STATIC.TILE] = {
        tileType: Ntry.STATIC.OBSTACLE_METEO
    }
    return {components: components};
};

Ntry.createSpaceShip = function(spaceShip) {
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: spaceShip.x, y: spaceShip.y
    };
    components[Ntry.STATIC.BITMAP] = {
        image: 'ship',
        regX: 25, regY: 25
    }
    components[Ntry.STATIC.SPACE_SHIP] = {
    }
    components[Ntry.STATIC.RADAR] = {
    }
    components[Ntry.STATIC.UNIT] = {
    }
    components[Ntry.STATIC.SCRIPT_CONTAINER] = {
        script: spaceShip.userScript || spaceShip.script
    };
    return {components: components};
};

Ntry.createCodeSpaceShip = function(spaceShip) {
    var components = {};
    components[Ntry.STATIC.GRID] = {
        x: spaceShip.x, y: spaceShip.y
    };
    components[Ntry.STATIC.BITMAP] = {
        image: 'ship',
        regX: 25, regY: 25
    }
    components[Ntry.STATIC.SPACE_SHIP] = {
    }
    components[Ntry.STATIC.RADAR] = {
    }
    components[Ntry.STATIC.UNIT] = {
    }

    components[Ntry.STATIC.CODE] = {code: spaceShip.userCode || spaceShip.code};
    return {components: components};
};

Ntry.parseTexttoXML = function(xmlText) {
    if (window.ActiveXObject){
        var doc=new ActiveXObject('Microsoft.XMLDOM');
        doc.async='false';
        doc.loadXML(xmlText);
    } else {
        var parser=new DOMParser();
        var doc=parser.parseFromString(xmlText,'text/xml');
    }
    return doc;
};

Ntry.changeXmlHashId = function(xmlBlock) {
    var reg = /function_field/;
    if (reg.test(xmlBlock.getAttribute('type'))) {
        var mutations = xmlBlock.getElementsByTagName('mutation');
        for (var i=0, len=mutations.length; i<len; i++)
            mutations[i].setAttribute('hashid', Ntry.Utils.generateHash());
    }
    return xmlBlock;
}

Ntry.compareObjects = function(o1, o2) {
    for(var p in o1){
        if(o1.hasOwnProperty(p)){
            if(o1[p] !== o2[p]){
                return false;
            }
        }
    }
    for(var p in o2){
        if(o2.hasOwnProperty(p)){
            if(o1[p] !== o2[p]){
                return false;
            }
        }
    }
    return true;
}

Ntry.addVectorByDirection = function(vector, direction, delta) {
    switch(direction) {
        case Ntry.STATIC.NORTH:
            vector.y -= delta;
            break;
        case Ntry.STATIC.EAST:
            vector.x += delta;
            break;
        case Ntry.STATIC.SOUTH:
            vector.y += delta;
            break;
        case Ntry.STATIC.WEST:
            vector.x -= delta;
            break;
    }
    return vector;
}

Ntry.computeThread = function(entity, script) {
    var isSame = false;
    var isContinue = true;
    try {
        var newScript = script.run(entity);
        //isContinue = !script.isRepeat;
        //isSame = (newScript && newScript.type == script.type);
        script = newScript;
    } catch (exception) {
        throw exception;
    }
    return script;
};

Ntry.countUsedBlocks = function() {
    var headBlocks = [
        'ai_start',
        'ai_start_un',
        'maze_step_start',
        'maze_step_unstart',
        'maze_define_unfunction',
        'maze_define_function'
    ];
    var banList = [
        'number',
        'number_un',
        'True',
        'True_un'
    ];

    var cnt = 0;
    if (!Blockly.mainWorkspace)
        return false;
    var topBlocks = Blockly.mainWorkspace.getTopBlocks();
    _.each(topBlocks, function(b){
        if (headBlocks.indexOf(b.type) > -1) {
            var childs = b.getDescendants();
            _.each(childs, function(subB){
                if (banList.indexOf(subB.type) < 0)
                    cnt++;
            });
        }
    });
    return cnt;
};

Ntry.getBrowserType = function() {
    if (Ntry.userAgent)
        return Ntry.userAgent;
   var ua= navigator.userAgent, tem,
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE '+(tem[1] || '');
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    var uaResult = M.join(' ');
    Ntry.userAgent = uaResult;
    return uaResult;
};

Ntry.goToUrl = function(url) {
    window.location.href = url;
};
